export class DropdownItemModel {
  id: number;
  name: string;
  description: string;
  code: string;
  needsDetails: boolean;
  children: DropdownItemModel[];
}
